module.exports = __webpack_public_path__ + "img/paper.65701c55.png";